import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentStatusesComponent } from './document-statuses.component';
import { EditDocumentStatusesComponent } from './edit-document-statuses/edit-document-statuses.component';
import { AddDocumentStatusesComponent } from './add-document-statuses/add-document-statuses.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        DocumentStatusesComponent,
        EditDocumentStatusesComponent,
        AddDocumentStatusesComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [DocumentStatusesComponent]
})
export class DocumentStatusesModule { }
